
/**
 * This file is auto-generated. Don't make changes made here — they will be owerwritten.
 */

// --------------------------------------------------------------
// Shared
// --------------------------------------------------------------


// --------------------------------------------------------------
// Components
// --------------------------------------------------------------

import ArticleList from '../../Features/Components/ArticleList/Scripts/index.js';
import BurgerMenu from '../../Features/Components/BurgerMenu/Scripts/index.js';
import ButtonBlock from '../../Features/Components/ButtonBlock/Scripts/index.js';
import CheckoutForm from '../../Features/Components/CheckoutForm/Scripts/index.js';
import Container from '../../Features/Components/Container/Scripts/index.js';
import CookieConsent from '../../Features/Components/CookieConsent/Scripts/index.js';
import CookieSettings from '../../Features/Components/CookieSettings/Scripts/index.js';
import Faq from '../../Features/Components/Faq/Scripts/index.js';
import Header from '../../Features/Components/Header/Scripts/index.js';
import InfoBox from '../../Features/Components/InfoBox/Scripts/index.js';
import NavigationCard from '../../Features/Components/NavigationCard/Scripts/index.js';
import NewsList from '../../Features/Components/NewsList/Scripts/index.js';
import PublicationInfo from '../../Features/Components/PublicationInfo/Scripts/index.js';
import PublicationList from '../../Features/Components/PublicationList/Scripts/index.js';
import RulingList from '../../Features/Components/RulingList/Scripts/index.js';
import SearchFilter from '../../Features/Components/SearchFilter/Scripts/index.js';
import SearchResult from '../../Features/Components/SearchResult/Scripts/index.js';
import SecondaryNavigation from '../../Features/Components/SecondaryNavigation/Scripts/index.js';
import ShoppingCart from '../../Features/Components/ShoppingCart/Scripts/index.js';

// --------------------------------------------------------------
// Media
// --------------------------------------------------------------


// --------------------------------------------------------------
// Pages
// --------------------------------------------------------------

import Article from '../../Features/Pages/Article/Scripts/index.js';
import Commission from '../../Features/Pages/Commission/Scripts/index.js';
import ErrorPage from '../../Features/Pages/ErrorPage/Scripts/index.js';
import List from '../../Features/Pages/List/Scripts/index.js';
import News from '../../Features/Pages/News/Scripts/index.js';
import Opinion from '../../Features/Pages/Opinion/Scripts/index.js';
import Publication from '../../Features/Pages/Publication/Scripts/index.js';
import Search from '../../Features/Pages/Search/Scripts/index.js';
import Section from '../../Features/Pages/Section/Scripts/index.js';
import Start from '../../Features/Pages/Start/Scripts/index.js';
import Subsection from '../../Features/Pages/Subsection/Scripts/index.js';
import Support from '../../Features/Pages/Support/Scripts/index.js';

export const components = [
    ArticleList,
    BurgerMenu,
    ButtonBlock,
    CheckoutForm,
    Container,
    CookieConsent,
    CookieSettings,
    Faq,
    Header,
    InfoBox,
    NavigationCard,
    NewsList,
    PublicationInfo,
    PublicationList,
    RulingList,
    SearchFilter,
    SearchResult,
    SecondaryNavigation,
    ShoppingCart,
    Article,
    Commission,
    ErrorPage,
    List,
    News,
    Opinion,
    Publication,
    Search,
    Section,
    Start,
    Subsection,
    Support
];
